export default {
  namespaced: true,
  state:{
    clients: [],
    period: { year: null, month: null },
    supervisors: [],
    budgetDialog: {
      modal: false,
      clientId: null,
      clientName: '',
      budgets: []
    },
    supervisorDialog: {
      modal: false,
      clientId: null,
      clientName: '',
      history: []
    }
  },
  getters:{
    clients: state => state.clients,
    period: state => state.period,
    supervisors: state => state.supervisors,
    budgetDialog: state => state.budgetDialog,
    supervisorDialog: state => state.supervisorDialog
  },
  mutations:{
    SET_CLIENTS(state, value){
      state.clients = value;
    },
    SET_PERIOD(state, value){
      state.period = value;
    },
    SET_SUPERVISORS(state, value){
      state.supervisors = value;
    },
    SET_BUDGET_DIALOG(state, value){
      state.budgetDialog = Object.assign({}, state.budgetDialog, value);
    },
    SET_SUPERVISOR_DIALOG(state, value){
      state.supervisorDialog = Object.assign({}, state.supervisorDialog, value);
    }
  },
  actions:{
    getClients({ commit }, payload) {
      const params = payload || {};
      return new Promise((resolve, reject) => {
        axios.get('admin/client-stock-profiles', { params }).then((response) => {
          commit('SET_CLIENTS', response.data.data.clients);
          commit('SET_PERIOD', response.data.data.period);
          resolve(response);
        })
        .catch(error => reject(error));
      });
    },
    getSupervisors({ commit }) {
      return new Promise((resolve, reject) => {
        axios.get('admin/client-supervisors/available-supervisors').then((response) => {
          commit('SET_SUPERVISORS', response.data.data);
          resolve(response);
        })
        .catch(error => reject(error));
      });
    },
    updateProfile({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios.put('admin/client-stock-profiles/' + payload.client_id, { buys_products: payload.buys_products })
          .then(response => resolve(response))
          .catch(error => reject(error));
      });
    },
    getClientDetail({ commit }, clientId) {
      return new Promise((resolve, reject) => {
        axios.get('admin/client-stock-profiles/' + clientId).then((response) => {
          commit('SET_BUDGET_DIALOG', {
            clientId: clientId,
            clientName: response.data.data.client_name,
            budgets: response.data.data.budgets
          });
          resolve(response);
        })
        .catch(error => reject(error));
      });
    },
    storeBudget({ dispatch }, payload) {
      return new Promise((resolve, reject) => {
        axios.post('admin/client-stock-profiles/' + payload.client_id + '/budgets', payload)
          .then(response => resolve(response))
          .catch(error => reject(error));
      });
    },
    destroyBudget({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios.delete('admin/client-stock-profiles/' + payload.client_id + '/budgets/' + payload.budget_id)
          .then(response => resolve(response))
          .catch(error => reject(error));
      });
    },
    getSupervisorHistory({ commit }, clientId) {
      return new Promise((resolve, reject) => {
        axios.get('admin/client-supervisors/history/' + clientId).then((response) => {
          commit('SET_SUPERVISOR_DIALOG', { history: response.data.data });
          resolve(response);
        })
        .catch(error => reject(error));
      });
    },
    assignSupervisor({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios.post('admin/client-supervisors', payload)
          .then(response => resolve(response))
          .catch(error => reject(error));
      });
    },
    closeAssignment({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios.patch('admin/client-supervisors/' + payload.id + '/close', { valid_to: payload.valid_to })
          .then(response => resolve(response))
          .catch(error => reject(error));
      });
    }
  }
}
